
import classes from './NotificationComponent.module.css'
import NotificationItem from './NotificationItem'


const NotificationComponent = ({data}) => {
    console.log('data', data)
    return <>   
        <div className={classes.warning_container}>
            {data && data.length > 0 && data.map(error => (
                <NotificationItem key={error.id} id={error.id} type={error.type} timeOut={error.timeOut}>
                    {(typeof error.errorMessage == "string") && error.errorMessage}                   
         
                    {(typeof error.errorMessage !== "string") && <>
                        {error.errorMessage.errors && <ul>
                            {Object.entries(error.errorMessage.errors).map(err => (
                                <li key={err[0]} >{err[1]}</li>
                            ))}    
                        </ul>}

                        {error.errorMessage.length > 0 && <ul>
                            {error.errorMessage.map(item => (
                                <li key={item} >{item}</li>
                            ))}
                        </ul>}           
                        {error.errorMessage.message && error.errorMessage.message}
                    </>}
                </NotificationItem>
            ))}
        </div>
    </>
}

export default NotificationComponent